import { Result, Button } from "antd";
import styled from "styled-components";
import MainWrapper from "../components/MainWrapper";

const NotFoundWrapper = styled(Result)`
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // flex-direction: column;
  // height: 80vh;
  .ant-result-title,
  .ant-result-subtitle {
    color: white;
  }
`;

const NotFound = () => {
  return (
    <MainWrapper>
      <NotFoundWrapper
        status="404"
        title="404"
        style={{ color: "#fff" }}
        subTitle="Sorry, the page you visited does not exist."
        // extra={<Button type="primary">Back Home</Button>}
      />
    </MainWrapper>
  );
};

export default NotFound;
